import * as vp from 'vopay';
import { FunctionComponent, useEffect, useState } from 'react';
import { useHistory, useLocation, Link } from 'react-router-dom';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import { useClientData } from '../../../../providers/ClientData.provider';
import { useOpenModule } from '../../../../providers/OpenModule.provider';
import { useNavMenu } from '../../../../providers/NavMenu.provider';
import usePostDeleteClientBankAccount from '../../../../hooks/useApi/usePostDeleteClientBankAccount';
import usePostDeleteClientCreditCard from '../../../../hooks/useApi/usePostDeleteClientCreditCard';
import usePostDeleteInteracEmail from '../../../../hooks/useApi/usePostDeleteInteracEmail';
import usePostSetDefaultPaymentMethod from '../../../../hooks/useApi/usePostSetDefaultPaymentMethod';
import usePostSetMyClientBankAccount from '../../../../hooks/useApi/usePostSetMyClientBankAccount';
import usePostSetMyClientCreditCard from '../../../../hooks/useApi/usePostSetMyClientCreditCard';
import AccountDetails from './AccountDetails';
import style from '../BankAccount.module.scss';
import AccountContext, { AccountCtx } from '../Dialogue/AccountContext';
import AccountDialogue from '../Dialogue/AccountDialogue';
import { AccountDialogueHandler, DialogueHandlerProps } from '../Dialogue/types';
import { UtilButton } from 'UI';

const { Box, Title, Button, Tooltip, Toast } = vp;
export type Account = {
  Country?: string;
  Type?: string;
  ABARoutingNumber?: string;
  AccountHolderName?: string;
  AccountNumber?: string;
  Address?: string;
  BankId?: string;
  BranchTransitNumber?: string;
  City?: string;
  ClientAccountID?: string;
  ClientControlledBankAccount?: string;
  ClientReferenceNumber?: string;
  Currency?: string;
  DateAdded?: string;
  EmailAddress?: string;
  FinancialInstitutionNumber?: string;
  FlinksAccountID?: string;
  FlinksLoginID?: string;
  InstitutionName?: string;
  InveriteRequestGUID?: string;
  IsDefault?: string;
  Phone?: string;
  PlaidAccountID?: string;
  PostalCode?: string;
  Province?: string;
  Token?: string;
  CreditCardToken?: string;
  CreditCardHolderName?: string;
  CreditCardNumber?: string;
  CreditCardExpiryYear?: string;
  CreditCardExpiryMonth?: string;
  CreditCardBrand?: string;
  RecipientName?: string;
  RecipientEmailAddress?: string;
  RecipientPhoneNumber?: string;
  ID?: string;
  IsOperationalDefault?: string;
  IsBillingDefault?: string;
  IsDefaultAccount?: string;
};
type DataProps = {
  account: Account;
};

type AccountType = {
  AccountListingType?: 'Operational' | 'Billing';
};
type FC = FunctionComponent<AccountType>;
const MyBankAccountDetailsContainer: FC = (props: AccountType) => {
  const { t } = useTranslation('translations', {
    keyPrefix: 'Accounts.MyBankAccounts.Details.BankAccountDetailsContainer',
  });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const { AccountListingType = 'Operational' } = props;
  const history = useHistory();
  const location = useLocation<DataProps>();
  const { state } = location;
  const accountUser: Account = location.search ? (queryString.parse(location.search) as any as Account) : state.account;
  const { response } = useClientData();
  const { setOpenModule } = useOpenModule();
  const { onSubNavClick } = useNavMenu();
  const [token, setToken] = useState('');
  const [accountType, setAccountType] = useState('');
  const [account, setAccount] = useState(accountUser);
  const [isDialogueVisible, setIsDialogueVisible] = useState(false);
  const [deleteBankAccountResponse, postDeleteBankAccountResponse] = usePostDeleteClientBankAccount({});
  const [deleteCreditCardResponse, postDeleteCreditCardResponse] = usePostDeleteClientCreditCard({});
  const [deleteInteracEmailResponse, postDeleteInteracEmail] = usePostDeleteInteracEmail({});
  const [shouldDeleteBankAccount, setShouldDeleteBankAccount] = useState(false);
  const [shouldDeleteCreditCard, setShouldDeleteCreditCard] = useState(false);
  const [shouldDeleteInteracEmail, setShouldDeleteInteracEmail] = useState(false);
  const [showDeleteAccountConfirmAlert, setShowDeleteAccountConfirmAlert] = useState(false);
  const [showDeleteAccountErrorAlert, setShowDeleteAccountErrorAlert] = useState(false);
  const [showDeleteAccountSuccessAlert, setShowDeleteAccountSuccessAlert] = useState(false);
  const [showChangeDefualtBilling, setShowChangeDefualtBilling] = useState(false);
  const [showChangeDefualtOperational, setShowChangeDefualtOperational] = useState(false);
  const [showDeleteBillingConfirmAlert, setShowDeleteBillingConfirmAlert] = useState(false);
  const [operationalDefaultToast, setOperationalDefaultToast] = useState(false);
  const [billingDeafualtToast, setBillingDeafualtToast] = useState(false);
  const [deleteAccountError, setDeleteAccountError] = useState('');
  const [setDefaultPaymentMethodResponse, setDefaultPaymentMethod] = usePostSetDefaultPaymentMethod({});
  const [setDefautlBankAccountResponse, setDefautlBankAccount] = usePostSetMyClientBankAccount({});
  const [setDefaultCreditCardResponse, setDefaultCreditCard] = usePostSetMyClientCreditCard({});
  const accontNumber =
    account.AccountNumber ||
    account.CreditCardNumber ||
    account.RecipientEmailAddress ||
    account.RecipientPhoneNumber ||
    '';
  const accountTypeBank = account.Type || '';
  const accountName = account.AccountHolderName || account.CreditCardHolderName || '';
  const currency = account.Currency || 'CAD';
  const DeleteAccount: AccountCtx = {
    showDeleteAccountConfirmAlert,
    showDeleteAccountErrorAlert,
    showDeleteAccountSuccessAlert,
    showDeleteBillingConfirmAlert,
    showChangeDefualtBilling,
    showChangeDefualtOperational,
    deleteAccountError,
    showChangeDefualtOperationalSuccessfull: false,
    showChangeDefualtBillingSuccessfull: false,
    showAddTypeOfOperational: false,
    showAddTypeOfBilling: false,
    showAddOperational: false,
    showAddBilling: false,
    showAddOperationalSuccessfull: false,
    showAddBillingSuccessfull: false,
    accontNumber,
    accountType: accountTypeBank,
    accountName,
    currency,
    selectOptions: {},
    token: '',
    selectionChanged: () => {},
    paymentMehtod: '',
    paymentMethodChanged: () => {},
  };
  const setAccountDefault = (asDefault: boolean, defaultType?: 'vopay' | 'bank' | 'credit', token2?: string) => {
    if (defaultType === 'bank') {
      // set my bank account
      setDefautlBankAccount({
        PortalUser: response.LoginUserName,
        Token: token2 || '',
        SetAsDefault: asDefault,
        Purpose: AccountListingType.toLowerCase(),
      });
    }
    if (defaultType === 'credit') {
      // credit card set default
      setDefaultCreditCard({
        CreditCardToken: token2 || '',
        SetAsDefault: asDefault,
      });
    }
    if (AccountListingType === 'Billing') {
      setDefaultPaymentMethod({
        PortalUser: response.LoginUserName,
        PaymentMethod: defaultType || 'bank',
      });
    }
  };
  useEffect(() => {
    if (AccountListingType === 'Operational') {
      setShowChangeDefualtOperational(false);
    } else {
      setShowChangeDefualtBilling(false);
    }
  }, [setDefaultPaymentMethodResponse]);
  useEffect(() => {
    if (AccountListingType === 'Operational') {
      setShowChangeDefualtOperational(false);
    } else {
      setShowChangeDefualtBilling(false);
    }
    if (setDefautlBankAccountResponse.Success) {
      if (AccountListingType === 'Billing') {
        setAccount({
          ...account,
          IsBillingDefault: '1',
          IsDefaultAccount: '1',
          IsDefault: '1',
        });
        setBillingDeafualtToast(true);
      } else {
        setAccount({
          ...account,
          IsOperationalDefault: '1',
          IsDefaultAccount: '1',
          IsDefault: '1',
        });
        setOperationalDefaultToast(true);
      }
    }
  }, [setDefautlBankAccountResponse]);
  useEffect(() => {
    if (AccountListingType === 'Operational') {
      setShowChangeDefualtOperational(false);
    } else {
      setShowChangeDefualtBilling(false);
    }
    if (setDefaultCreditCardResponse.Success) {
      if (AccountListingType === 'Billing') {
        setAccount({
          ...account,
          IsBillingDefault: '1',
          IsDefaultAccount: '1',
          IsDefault: '1',
        });
        setBillingDeafualtToast(true);
      } else {
        setAccount({
          ...account,
          IsOperationalDefault: '1',
          IsDefaultAccount: '1',
          IsDefault: '1',
        });
        setOperationalDefaultToast(true);
      }
    }
  }, [setDefaultCreditCardResponse]);

  const handlers = {
    handleAccountDialogue: (handlerProps: DialogueHandlerProps<AccountDialogueHandler>) => {
      const { type, state: state2, action = 'default' } = handlerProps;

      const dialogueHandlers: AccountDialogueHandler = {
        delete: {
          confirm: {
            default: () => {
              setShowDeleteAccountSuccessAlert(false);
              history.goBack();
            },
          },
          fail: {
            default: () => {
              setShowDeleteAccountErrorAlert(false);
            },
          },
        },
        confirm: {
          confirm: {
            default: () => {
              setShowDeleteAccountConfirmAlert(false);
              setShowDeleteBillingConfirmAlert(false);
              if (accountType === 'Bank Account') {
                setShouldDeleteBankAccount(true);
              } else if (accountType === 'Credit Card') {
                setShouldDeleteCreditCard(true);
              } else if (accountType === 'Interac') {
                setShouldDeleteInteracEmail(true);
              }
            },
          },
          fail: {
            default: () => {
              setShowDeleteAccountConfirmAlert(false);
              setShowDeleteBillingConfirmAlert(false);
            },
          },
        },
        changeDefault: {
          confirm: {
            default: () => {
              setAccountDefault(
                true,
                account.Type === 'Credit Card' ? 'credit' : 'bank',
                account.Token || account.CreditCardToken || '',
              );
            },
          },
          fail: {
            default: () => {
              if (AccountListingType === 'Operational') {
                setShowChangeDefualtOperational(false);
              } else {
                setShowChangeDefualtBilling(false);
              }
            },
          },
        },
        successDefaultOperational: {},
        successDefaultBiliing: {},
        successAddOperational: {},
        successAddBiliing: {},
        operationalType: {},
        billingType: {},
        addBilling: {},
        addOperational: {},
      };
      const dialogueState = dialogueHandlers[type][state2];
      const handler = dialogueState ? dialogueState[action] || dialogueState.default : () => {};

      handler();
    },
  };

  useEffect(() => {
    if (account.Type === 'Bank Account') {
      setToken(account.Token || '');
    } else if (account.Type === 'Credit Card') {
      setToken(account.CreditCardToken || '');
    }
    setAccountType(account.Type || '');
  }, [account]);

  useEffect(() => {
    if (account.Type === 'Bank Account' && shouldDeleteBankAccount) {
      postDeleteBankAccountResponse({
        PortalUser: response.LoginUserName,
        Token: token,
      });
    } else if (account.Type === 'Credit Card' && shouldDeleteCreditCard) {
      postDeleteCreditCardResponse({
        PortalUser: response.LoginUserName,
        CreditCardToken: token,
      });
    } else if (account.Type === 'Interac' && shouldDeleteInteracEmail) {
      postDeleteInteracEmail({
        Token: token,
      });
    }
  }, [shouldDeleteBankAccount, shouldDeleteCreditCard, shouldDeleteInteracEmail]);
  const transitionAfterDelete = () => {
    if (AccountListingType === 'Billing') {
      history.push({
        pathname: '/account-and-billing',
        state: {
          name: account.AccountHolderName
            ? account.AccountHolderName
            : account.RecipientName
              ? account.RecipientName
              : account.CreditCardHolderName
                ? account.CreditCardHolderName
                : '',
          type: account.Type,
          isDelete: true,
        },
      });
    } else {
      history.push({
        pathname: '/operational-accounts',
        state: {
          name: account.AccountHolderName
            ? account.AccountHolderName
            : account.RecipientName
              ? account.RecipientName
              : account.CreditCardHolderName
                ? account.CreditCardHolderName
                : '',
          type: account.Type,
          isDelete: true,
        },
      });
    }
  };
  useEffect(() => {
    if (shouldDeleteBankAccount) {
      setShouldDeleteBankAccount(false);
      const { Success, ErrorMessage } = deleteBankAccountResponse;

      if (Success === true) {
        transitionAfterDelete();
      } else {
        setShowDeleteAccountErrorAlert(true);
        setDeleteAccountError(ErrorMessage);
      }
    }

    if (shouldDeleteCreditCard) {
      setShouldDeleteCreditCard(false);
      const { Success, ErrorMessage } = deleteCreditCardResponse;

      if (Success === true) {
        transitionAfterDelete();
      } else {
        setShowDeleteAccountErrorAlert(true);
        setDeleteAccountError(ErrorMessage);
      }
    }

    if (shouldDeleteInteracEmail) {
      setShouldDeleteInteracEmail(false);
      const { Success, ErrorMessage } = deleteInteracEmailResponse;

      if (Success === true) {
        transitionAfterDelete();
      } else {
        setShowDeleteAccountErrorAlert(true);
        setDeleteAccountError(ErrorMessage);
      }
    }
  }, [deleteBankAccountResponse, deleteCreditCardResponse, deleteInteracEmailResponse]);
  const setDefaultBank = () => {
    if (AccountListingType === 'Operational') {
      setShowChangeDefualtOperational(true);
    } else {
      setShowChangeDefualtBilling(true);
    }
  };
  return (
    <AccountContext.Provider value={DeleteAccount}>
      <Box flx="col" gapSize="16px">
        <UtilButton
          iconLeft="chevron_left"
          size="large"
          onClick={() => {
            if (history.length > 1) {
              history.goBack();
            } else {
              history.replace('/account-and-billing');
            }
          }}
        >
          {history.length > 1 ? tGlobal('Buttons.back') : t('title.accountBilling')}
        </UtilButton>
        <Box width="100%" flx="row" jc="sb">
          <Box mb="lg">
            <Title
              title={
                AccountListingType === 'Operational'
                  ? t('title.operationalAccountDetails')
                  : t('title.billingAccountDetails')
              }
            />
          </Box>
          <Box flx="row" gap="sm">
            {AccountListingType === 'Operational' && response.SubAccountType !== 'franchise' && (
              <Button
                id="add-funds-btn"
                label={t('button.addFunds')}
                color="secondary"
                width="100px"
                height="38px"
                bold
                onClick={() => {
                  setOpenModule('myAccount');
                  onSubNavClick('fundMyAccount', '/fund-my-account', t('nav.fundMyAccount'));
                  history.push({
                    pathname: '/fund-my-account',
                    state: {
                      token: account.Token,
                      type: account.Type,
                      currency: account.Currency,
                      cardToken: account.CreditCardToken,
                      interacID: account.ID,
                      account,
                    },
                  });
                }}
              />
            )}
            {account.Type !== 'Credit Card' &&
              AccountListingType === 'Operational' &&
              response.SubAccountType !== 'franchise' && (
                <Button
                  id="witdraw-btn"
                  label={t('button.withdraw')}
                  color="secondary"
                  width="100px"
                  height="38px"
                  onClick={() => {
                    setOpenModule('myAccount');
                    onSubNavClick('withdrawMyAccount', '/withdraw-my-account', t('nav.withdrawMyAccount'));
                    history.push({
                      pathname: '/withdraw-my-account',
                      state: {
                        token: account.Token,
                        type: account.Type,
                        currency: account.Currency,
                        cardToken: account.CreditCardToken,
                        interacID: account.ID,
                        account,
                      },
                    });
                  }}
                />
              )}
            {account.IsDefault === '0' &&
            !vp.toBool(account.IsOperationalDefault) &&
            !vp.toBool(account.IsBillingDefault) &&
            !vp.toBool(account.IsDefaultAccount) ? (
              <Button
                id="delete-contact"
                label={t('button.delete')}
                color="secondary"
                width="100px"
                height="38px"
                onClick={() => {
                  if (AccountListingType === 'Operational') {
                    setShowDeleteAccountConfirmAlert(true);
                  } else {
                    setShowDeleteBillingConfirmAlert(true);
                  }
                }}
              />
            ) : (
              <div className={[style.dialogueContainer, style.LinkColorLine, style.linkLine].join(' ')}>
                <Button
                  id="delete-contact"
                  label={t('button.delete')}
                  textColor="#747474"
                  background="#c4c4c4"
                  width="100px"
                  height="38px"
                  bold
                  onClick={() => {
                    setIsDialogueVisible(!isDialogueVisible);
                  }}
                />
                <Tooltip
                  hasButton={false}
                  information={
                    <>
                      {t('tooltip.cannotDeleteDefaultAccount')}
                      <Link
                        to="/account-and-billing"
                        onClick={() => {
                          setOpenModule('dashboard');
                        }}
                      >
                        {t('tooltip.billingDetails')}
                      </Link>
                    </>
                  }
                  position="bottom"
                  hasArrow={false}
                  icon="question"
                  positionX="-70%"
                  positionY="100%"
                  isDialogueVisible={isDialogueVisible}
                />
              </div>
            )}
          </Box>
        </Box>
        <AccountDetails account={account} setDefaultBank={setDefaultBank} AccountListingType={AccountListingType} />
        <Toast
          isVisible={operationalDefaultToast}
          label={`${
            account.AccountHolderName
              ? account.AccountHolderName
              : account.CreditCardHolderName
                ? account.CreditCardHolderName
                : ''
          } ${tGlobal(`Accounts.MyBankAccounts.accountTypeItem.${account.Type || ' '}`)} ${t(
            'toast.addDefaultOperationalSuccess',
          )}`}
        />
        <Toast
          isVisible={billingDeafualtToast}
          label={`${
            account.AccountHolderName
              ? account.AccountHolderName
              : account.CreditCardHolderName
                ? account.CreditCardHolderName
                : ''
          } ${tGlobal(`Accounts.MyBankAccounts.accountTypeItem.${account.Type || ' '}`)} ${t(
            'toast.addDefaultBillingSuccess',
          )}`}
        />
      </Box>
      <AccountDialogue handleAccountDialogue={handlers.handleAccountDialogue} />
    </AccountContext.Provider>
  );
};

export default MyBankAccountDetailsContainer;
